/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2021
 * @format
 * @flow
 */

import React from 'react';
import classNames from 'classnames';
import CardList from './CardList';
import SearchBox from "../SearchBox";
import CalendarFilter from "../CalendarFilter";
import classes from './CheckTilesView.module.css';
import modeEnums from '../../../../enums/modeEnums';

const CheckTilesView = props => {
  const {
    checksRowData = [],
    setSelectedCheck = () => { },
    selectedItem = {},
    showSearchBox,
    value,
    onSearchReset,
    handleChange,
    searchChecks,
    selectedDate,
    onDateChange,
    onlineOrderAdvanceLimit,
    resetFilterCalendar,
    isFutureOrderType,
    managerMode,
    activeMgrFilter,
    checkFilters,
    storeInfo,
    onHandleSms,
    updateOrderStatus,
    deviceGroup,
    currentMode,
    viewGuestLocationOnMap,
    onOrderDelivered,
  } = props;

  const getChecksFiltered = () => {
    let filteredChecks = checksRowData || [];
    if (managerMode) {
      let filterFunction = () => true;
      switch (activeMgrFilter) {
        case 'pre-auth': {
          filterFunction = check => check.tickets && check.tickets.some(tkt => tkt.preAuth && tkt.ticketStatusId === 0 && check.unpaidAmount > 0);
          break;
        }
        case 'over-serve': {
          filterFunction = check => {
            return check.relatedNotifications.some(n => n.notificationTypeId === 15 && n.data.checkHeaderId === check.id);
          };
          break;
        }
        case 'id-check': {
          filterFunction = check => {
            return check.relatedNotifications.some(n => n.notificationTypeId === 14 && n.data.checkHeaderId === check.id);
          };
          break;
        }
        default: {
          filterFunction = () => true;
          break;
        }
      }
      filteredChecks = checksRowData.filter(filterFunction);
    }

    if (currentMode === modeEnums.GPS_LOCATION) {
      filteredChecks = filteredChecks.filter(check => {
        const { orders } = check || {};
        const [order0] = orders || [];
        const { pickUpStatus } = order0 || {};
        return pickUpStatus === 0;
      });
    } else if (currentMode === modeEnums.TABLE_DELIVERY) {
      //should not display voided checks
      filteredChecks = filteredChecks.filter(check => {
        const { orders } = check;
        const [order0] = orders || [];
        if (check?.void === true || orders?.length === 0 || order0?.orderStatusId === 10)
          return false;
        return true;
      });
    }

    return filteredChecks;
  };

  const getGridHeight = () => {
    if (showSearchBox && selectedDate && isFutureOrderType) return '77vh';
    else if (showSearchBox) return '85vh';
    else if (selectedDate && isFutureOrderType) return '84vh';
    else return '92vh';
  };

  return (
    <div className={classes.checks}>
      {showSearchBox ? (
        <SearchBox
          value={value}
          onSearchReset={onSearchReset}
          handleChange={handleChange}
          searchChecks={searchChecks}
        />
      ) : null}
      {selectedDate && isFutureOrderType ? (
        <CalendarFilter
          selectedDate={selectedDate}
          onDateChange={onDateChange}
          onlineOrderAdvanceLimit={onlineOrderAdvanceLimit}
          resetFilterCalendar={resetFilterCalendar}
        />
      ) : null}
      <div
        style={{ height: getGridHeight() }}
        className={classNames({
          [classes.defaultContainerStyle]: true,
          [classes.futureOrdersContainerStyle]: isFutureOrderType && checksRowData.length,
        })}
      >
        <CardList
          checks={getChecksFiltered()}
          managerMode={managerMode}
          setSelectedCheck={setSelectedCheck}
          selectedItem={selectedItem}
          checkFilters={checkFilters}
          storeInfo={storeInfo}
          onHandleSms={onHandleSms}
          updateOrderStatus={updateOrderStatus}
          deviceGroup={deviceGroup}
          currentMode={currentMode}
          viewGuestLocationOnMap={viewGuestLocationOnMap}
          onOrderDelivered={onOrderDelivered}
        />
      </div>
    </div>
  );
};

export default CheckTilesView;
